import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import CancelIcon from '@mui/icons-material/Cancel';
import { grey, lightGreen, red } from '@mui/material/colors';
import { useFormContext, useWatch } from 'react-hook-form';
import { LenderFieldMap } from '@trnsact/trnsact-shared-types';
import { sanitizeFormKey } from 'modules/vendorOpportunity/dynamicLenderSubmissionMappings/lib';
import {
  LenderMappingsFormValues,
  LenderFieldMapWithErrors,
} from 'modules/vendorOpportunity/dynamicLenderSubmissionMappings/types';

interface Props {
  field: LenderFieldMapWithErrors;
}

export const MappingStatusIcon = ({ field }: Props) => {
  const { getFieldState, formState } = useFormContext<LenderMappingsFormValues>();
  const fieldName = `mappingsByLenderProperty.${sanitizeFormKey(field.lenderProperty!)}.mappedValue` as const;

  const mappedValue = useWatch({ name: fieldName });

  const isMapped = !!mappedValue || mappedValue === 0;
  const isRequired = field.details?.required === 'REQUIRED';
  const { error: rhfFieldError, isTouched, isDirty } = getFieldState(fieldName, formState);
  let hasErrors = !!field.details?.errors?.length || !!rhfFieldError;

  if (field.details?.fieldInputType === 'OPTION_SET' && isMapped) {
    const validOption = field.details.optionSets?.find(option => option?.lenderValue === mappedValue);
    hasErrors = !validOption;
  }

  if (!isMapped) {
    return (
      <>
        {isRequired ? (
          <>
            <CancelIcon sx={{ color: red[500] }} />
            <ArrowRightAltIcon sx={{ color: grey[400] }} />
          </>
        ) : (
          <>
            <CancelIcon sx={{ color: grey[400] }} />
            <ArrowRightAltIcon sx={{ color: grey[400] }} />
          </>
        )}
      </>
    );
  }

  return (
    <>
      {hasErrors ? (
        <>
          <CancelIcon sx={{ color: red[500] }} />
          <ArrowRightAltIcon sx={{ color: grey[400] }} />
        </>
      ) : (
        <>
          <CheckCircleIcon sx={{ color: lightGreen[500] }} />
          <ArrowRightAltIcon sx={{ color: lightGreen[500] }} />
        </>
      )}
    </>
  );
};
